/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import { Menu, MenuItem, ListItemIcon } from "@mui/material";
import { ArgosDownloadIcon } from "../../../../../../components/Icons/ArgosActionIcons";
import { GreenLineDataSetStates } from "../../../../types";

interface MoreMenuProps {
  anchorEl: HTMLElement | null;
  isOpen: boolean;
  onClose: () => void;
  handleDownload: (greenlineDatasetId: string) => void;
  greenlineDatasetId: string;
  isGreenlineRunning: boolean;
  dataSetState: GreenLineDataSetStates;
  blueLineState: GreenLineDataSetStates;
}

/**
 * This component renders the More menu when you press the More icon in the actions column in the table of sensors in green line app.
 */
const MoreMenu: React.FC<MoreMenuProps> = ({
  anchorEl,
  isOpen,
  onClose,
  handleDownload,
  greenlineDatasetId,
  isGreenlineRunning,
  dataSetState,
  blueLineState
}) => {
  return (
    <Menu
      id={"more-menu"+greenlineDatasetId}
      anchorEl={anchorEl}
      open={isOpen}
      onClose={onClose}
    >
      <MenuItem
        key={"download"+greenlineDatasetId}
        onClick={() => handleDownload(greenlineDatasetId)}
        // TODO: Can review this in future, but for now we might want user to be able to download even if not COMPLETED eg if changed back to PENDING but want to download previous data.
        // disabled={isGreenlineRunning || (dataSetState !== GreenLineDataSetStates.COMPLETE && blueLineState !== GreenLineDataSetStates.COMPLETE)}
      >
        <ListItemIcon>
          <ArgosDownloadIcon />
        </ListItemIcon>
        Download
      </MenuItem>
    </Menu>
  );
};

export default MoreMenu;